import React, { FC, useState } from 'react';
import { VoidFn } from 'types/baseTypes';
import { BackIcon } from 'assets/icons';
import { JobLeadSourceTypes, LeadSource } from '../constant';
import { CustomButton, CustomInput, RadioWithLabel } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';

interface EditLeadSourcePanelProps {
  onBackClick: VoidFn;
  leadSource: string;
  leadSourceType: string;
  onSaveClick: (leadSourceType: string, leadSource: string) => Promise<void>;
  isActionInProgress: boolean;
}

const EditLeadSourcePanel: FC<EditLeadSourcePanelProps> = ({
  onBackClick,
  leadSource,
  leadSourceType,
  onSaveClick,
  isActionInProgress
}) => {
  const [jobLeadSource, setJobLeadSource] = useState(leadSource);
  const [jobLeadSourceType, setJobLeadSourceType] = useState(leadSourceType);
  const hasLeadSource = jobLeadSourceType === LeadSource.REFERRAL || jobLeadSourceType === LeadSource.OTHER;

  const onLeadSourceChange = (sourceType: string) => {
    if (sourceType === leadSourceType) {
      setJobLeadSource(leadSource);
    } else setJobLeadSource('');
    setJobLeadSourceType(sourceType);
  };

  const isSaveDisabled = () =>
    (jobLeadSource.trim() === leadSource.trim() && leadSourceType === jobLeadSourceType) ||
    (hasLeadSource ? jobLeadSource.trim() === '' : false);

  return (
    <div className="h-full w-96">
      <div className="flex items-center border-b border-secondaryBtn py-4">
        <BackIcon className="mx-4 cursor-pointer" id="job-details-panel-back-arrow" onClick={onBackClick} />
        <div className="text-17px font-semibold text-headingGray">Lead source</div>
      </div>
      <div className="flex flex-col gap-y-6 px-4 py-6">
        {JobLeadSourceTypes.map(sourceType => (
          <div key={sourceType.value}>
            <RadioWithLabel
              isSelected={sourceType.value === jobLeadSourceType}
              label={sourceType.label}
              onClick={() => onLeadSourceChange(sourceType.value)}
              labelStyle={{ fontWeight: 600 }}
            />
            {sourceType.hasSource && sourceType.value === jobLeadSourceType && (
              <CustomInput
                id="edit-lead-source-type-input"
                value={jobLeadSource}
                className="mx-6 mt-2 rounded-md border border-borderGray bg-transparent focus:outline-none"
                onChange={setJobLeadSource}
                placeholder={sourceType.inputPlaceholder}
              />
            )}
          </div>
        ))}
      </div>
      <div className="flex w-full flex-col gap-y-4 p-4">
        <CustomButton
          id="edit-lead-source-save-button"
          className="w-full"
          onClick={() => onSaveClick(jobLeadSourceType, jobLeadSource.trim())}
          disabled={isSaveDisabled()}
          isLoading={isActionInProgress}>
          Save
        </CustomButton>
        <CustomButton
          id="edit-lead-source-cancel-button"
          className="w-full"
          onClick={onBackClick}
          type={ButtonType.SECONDARY}>
          Cancel
        </CustomButton>
      </div>
    </div>
  );
};

export default EditLeadSourcePanel;
